import React from 'react';
import colors from '../../utils/colors';
import LargeButton from '../ui/LargeButton';

import {
  TrashIcon,
  CreateIcon
} from '../../utils/icons';


const Footer = ({ onClearAll, onCreateSong, isCreateDisabled = false, showClearButton = false }) => {
  return (
    <div 
      className="flex justify-start items-start w-full relative gap-2 p-4"
      style={{
        background: `linear-gradient(to bottom, rgba(14,8,8,0) 0%, ${colors.bg.primary} 100%)`
      }}
    >
      {/* Clear All Button - Only show if there's content to clear */}
      {showClearButton && (
        <LargeButton
          variant="secondary"
          leftIcon={<TrashIcon />}
          onClick={onClearAll}
          className="flex-shrink-0"
        />
      )}

      {/* Create Button */}
      <LargeButton
        variant={isCreateDisabled ? 'inactive' : 'aura'}
        leftIcon={<CreateIcon />}
        text="Create"
        onClick={onCreateSong}
        disabled={isCreateDisabled}
        className="flex-1 w-full"
      />
    </div>
  );
};

export default Footer;